import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import type { OfferSelectOption } from '@core/offers-ui';
import type { TimeData } from '@core/time-ui';
import type { SelectGroupedOptions } from '@core/user-interface-legacy';
import {
  RequestEvaluationDropdownContext,
  RequestEvaluationDropdownForm,
} from '@recruitee/evaluations-types';
import type { EvaluationDueDateConfig, EvaluationSendAtKind } from '@recruitee/evaluations-types';
import {
  EvaluationAdminsFormControlComponent,
  EvaluationDueDateFormControlComponent,
  EvaluationFormControlComponent,
  EvaluationRelativeDueDateFormControlComponent,
  EvaluationSendAtKindFormControlComponent,
} from '@recruitee/evaluations-ui';

import { EvaluationJobFieldComponent } from '../../../common/evaluation-job-field/evaluation-job-field.component';

@Component({
  selector: 'rt-request-evaluation-dropdown-form',
  templateUrl: './request-evaluation-dropdown-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    EvaluationJobFieldComponent,
    EvaluationFormControlComponent,
    EvaluationAdminsFormControlComponent,
    EvaluationDueDateFormControlComponent,
    EvaluationRelativeDueDateFormControlComponent,
    EvaluationSendAtKindFormControlComponent,
  ],
})
export class RequestEvaluationDropdownFormComponent {
  public readonly form = input.required<RequestEvaluationDropdownForm>();
  public readonly groupedTemplates = input<SelectGroupedOptions[]>([]);
  public readonly templatesLoaded = input<boolean>(true);
  public readonly context = input.required<RequestEvaluationDropdownContext>();
  public readonly offers = input<OfferSelectOption[]>([]);
  public readonly canViewCandidates = input<boolean>(true);
  public readonly timeData = input<TimeData | null>(null);
  public readonly dueDateConfig = input<EvaluationDueDateConfig | null>(null);
  public readonly sendAtKind = input<EvaluationSendAtKind | null>(null);
  public readonly isSchedulerLink = input<boolean>(false);

  public readonly editAssignments = output<void>();
  public readonly timeDataChange = output<TimeData | null>();
  public readonly dueDateConfigChange = output<EvaluationDueDateConfig | null>();
  public readonly sendAtKindChange = output<EvaluationSendAtKind>();

  protected showJobControl = computed(
    () => this.offers().length > 1 && this.context() === RequestEvaluationDropdownContext.Default,
  );
  protected showDueDate = computed(
    () => this.context() === RequestEvaluationDropdownContext.Default,
  );
  protected showRelativeDueDate = computed(
    () => this.context() === RequestEvaluationDropdownContext.Scheduler,
  );
  protected showSendAtKind = computed(
    () => this.context() === RequestEvaluationDropdownContext.Scheduler,
  );
}
